<template>
  <div :style="styleObj" class="deck-thumb flex-row align-center center">
    <SlideFrame :theme="deck.themeData" :showLogo="false" :options="firstSlide.options">
      <slot />
    </SlideFrame>
  </div>
</template>
<script>
import SlideFrame from '~/components/SlideFrame'

export default {
  components: {
    SlideFrame
  },
  props: {
    deck: {
      type: Object,
      required: true,
      default: () => { return {} }
    }
  },
  computed: {
    slides () {
      return this.deck.slides || []
    },
    firstSlide () {
      return this.slides[0] || {}
    },
    slide () {
      return this.firstSlide || {}
    },
    options () {
      return this.firstSlide?.options || {}
    },
    theme () {
      return this.deck?.themeData || {}
    },
    fonts () {
      return this.theme.fonts || {}
    },
    colors () {
      if (this.options && this.options.colors && this.options.colors.name) { return this.options.colors.colors }
      if (this.theme && this.theme.colors && this.theme.colors.name) { return this.theme.colors.colors }
      return {}
    },
    styleObj () {
      const theme = this.options.colors ? this.options.colors : this.theme
      const isDark = theme.colors && theme.colors.brightness === 'dark'
      const contrast = isDark ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.35)'
      const highContrast = isDark ? 'rgba(255,255,255,.5)' : 'rgba(0,0,0,.5)'
      const lowContrast = isDark ? 'rgba(255,255,255,.15)' : 'rgba(0,0,0,.15)'
      const fullContrast = isDark ? '#fff' : '#000'

      const fontFamily = this.fonts.paragraph ? this.fonts.paragraph : 'Open Sans'

      return {
        backgroundColor: this.colors.primary,
        color: this.colors.text,
        'font-family': fontFamily || 'Open Sans',
        '--primary': this.colors.primary,
        '--secondary': this.colors.secondary,
        '--accent': this.colors.accent,
        '--text': this.colors.text,
        '--contrast': contrast,
        '--highContrast': highContrast,
        '--fullContrast': fullContrast,
        '--lowContrast': lowContrast,
        '--titleFont': this.fonts.title ? this.fonts.title : 'Open Sans',
        '--paraFont': fontFamily || 'Open Sans'
        // '--slideHeight': this.slideHeight + 'px',
        // '--slideWidth': this.slideWidth + 'px'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.deck-thumb {
  position: relative;
  height: 140px;
  width: 100%;
  border-radius: 5px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  overflow: hidden;
  box-shadow: none;
  // margin-bottom: -5px;
}
</style>
